<script>
export default {
  props: ["borderClr", "lineClr", "headClr", "bodyClr"]
};
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="120"
    height="120"
    viewBox="0 0 120 120"
    fill="none"
  >
    <g clip-path="url(#clip0_868_107831)">
      <path
        d="M40.2861 80.8121C40.2861 77.5088 41.5984 74.3408 43.9341 72.005C46.2699 69.6693 49.4379 68.3571 52.7411 68.3571H67.0411C70.3444 68.3571 73.5124 69.6693 75.8481 72.005C78.1839 74.3408 79.4961 77.5088 79.4961 80.8121V80.8121"
        :stroke="bodyClr ? bodyClr : '#768391'"
        stroke-width="3.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M68.3077 39.486C69.9714 41.1505 71.1042 43.2709 71.563 45.5791C72.0217 47.8873 71.7857 50.2797 70.8849 52.4538C69.984 54.628 68.4588 56.4862 66.5019 57.7935C64.5451 59.1009 62.2446 59.7987 59.8912 59.7987C57.5379 59.7987 55.2373 59.1009 53.2805 57.7935C51.3237 56.4862 49.7984 54.628 48.8976 52.4538C47.9967 50.2797 47.7608 47.8873 48.2195 45.5791C48.6782 43.2709 49.811 41.1505 51.4747 39.486C52.5798 38.3804 53.8919 37.5034 55.336 36.905C56.7802 36.3066 58.328 35.9987 59.8912 35.9987C61.4544 35.9987 63.0023 36.3066 64.4464 36.905C65.8905 37.5034 67.2026 38.3804 68.3077 39.486Z"
        :fill="headClr ? headClr : '#500FE9'"
      />
      <path
        d="M68.3077 39.486C69.9714 41.1505 71.1042 43.2709 71.563 45.5791C72.0217 47.8873 71.7857 50.2797 70.8849 52.4538C69.984 54.628 68.4588 56.4862 66.5019 57.7935C64.5451 59.1009 62.2446 59.7987 59.8912 59.7987C57.5379 59.7987 55.2373 59.1009 53.2805 57.7935C51.3237 56.4862 49.7984 54.628 48.8976 52.4538C47.9967 50.2797 47.7608 47.8873 48.2195 45.5791C48.6782 43.2709 49.811 41.1505 51.4747 39.486C52.5798 38.3804 53.8919 37.5034 55.336 36.905C56.7802 36.3066 58.328 35.9987 59.8912 35.9987C61.4544 35.9987 63.0023 36.3066 64.4464 36.905C65.8905 37.5034 67.2026 38.3804 68.3077 39.486"
        :stroke="headClr ? headClr : '#500FE9'"
        stroke-width="3.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M37.5 15H25C22.3478 15 19.8043 16.0536 17.9289 17.9289C16.0536 19.8043 15 22.3478 15 25V37.5M15 82.5V95C15 97.6522 16.0536 100.196 17.9289 102.071C19.8043 103.946 22.3478 105 25 105H37.5M82.5 105H95C97.6522 105 100.196 103.946 102.071 102.071C103.946 100.196 105 97.6522 105 95V82.5M105 37.5V25C105 22.3478 103.946 19.8043 102.071 17.9289C100.196 16.0536 97.6522 15 95 15H82.5"
        :stroke="borderClr ? borderClr : '#000022'"
        stroke-width="3.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.666 54H101.116"
        :stroke="lineClr ? lineClr : '#000022'"
        stroke-width="4"
        stroke-linecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_868_107831">
        <rect width="120" height="120" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
